import angular from 'angular';
import uiRouter from 'angular-ui-router';

import HistoryMessageComponent from './history.component';

const historyMessageModule = angular.module('tinaba.components.messageOutbound.history', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('messageOutbound.history', {
    url: '/history',
    template: '<history-message></history-message>'
  });
})

.component('historyMessage', HistoryMessageComponent);

export default historyMessageModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/history/history.js
 **/